import { get as getCookie } from 'es-cookie';
import { getStoredAccount } from './account-storage';

const AUTH_SESSION_NAME = '__xpl-gh-auth-session';

export async function translateBBaccountUuidToId(
  uuid: string,
): Promise<number | null> {
  const storedAccount = getStoredAccount();
  if (storedAccount) {
    const storedUuid: string | undefined = storedAccount.uuid;
    if (
      typeof storedUuid === 'string' &&
      storedUuid.toLowerCase() === uuid.toLowerCase()
    ) {
      return storedAccount.id;
    }
  }

  try {
    const token = getCookie(AUTH_SESSION_NAME);
    const headers: Record<string, string> = {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    const res = await fetch(
      `${process.env.BRANDBOT_API_URL}/accounts/details/${uuid}`,
      { headers },
    );

    if (!res.ok) {
      throw new Error(res.statusText);
    }

    const account = (await res.json()) as { id?: number };

    return typeof account?.id === 'number' ? account.id : null;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(e);

    return null;
  }
}
